import styled from "styled-components";
import MaterialInput from "../../helperComponents/MaterialInput";

const Container = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 900px) {
    width: 100%;
  }

  ${({ readOnly }) =>
    readOnly
      ? `
      opacity:0.9;
      pointer-events:none;
    `
      : ""}
`;

const Controls = styled.div`
  display: flex;
  gap: 6px;
`;

const TinyButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--element);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: var(--surface2);
  }
`;

export default function DailyResponsibilityField({
  label,
  values = [],
  readOnly,
  onChangeValue,
  onAdd,
  onRemove,
}) {
  const safeValues = Array.isArray(values) && values.length ? values : [""];

  return (
    <Container readOnly={readOnly}>
      {safeValues.map((value, index) => (
        <div key={`${label}-${index}`}>
          <MaterialInput
            style={{ flex: "unset" }}
            label={label}
            value={value || ""}
            onChange={(e) => {
              onChangeValue?.(index, e.target.value);
            }}
          />
          {readOnly ? null : (
            <Controls>
              <TinyButton onClick={onAdd} title="Ajouter un champ">
                +
              </TinyButton>
              {safeValues.length > 1 ? (
                <TinyButton
                  onClick={() => onRemove?.(index)}
                  title="Supprimer ce champ"
                >
                  -
                </TinyButton>
              ) : null}
            </Controls>
          )}
        </div>
      ))}
    </Container>
  );
}
